import template from './vault.create.html';
import controller from './vault.create.controller';
import './vault.create.controller';

let vaultcreateComponent = {
  restrict: 'E',
  bindings: {
    hasACL: '='
  },
  template,
  controller
};

export default vaultcreateComponent;


// WEBPACK FOOTER //
// ./client/app/components/vault/create/vault.create.component.js